import { render, staticRenderFns } from "./PostPurchaseCoupon.vue?vue&type=template&id=ed7553ba"
import script from "./PostPurchaseCoupon.vue?vue&type=script&lang=js"
export * from "./PostPurchaseCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports